import { render, staticRenderFns } from "./Transmission.vue?vue&type=template&id=5428bd5f&scoped=true&"
import script from "./Transmission.vue?vue&type=script&lang=js&"
export * from "./Transmission.vue?vue&type=script&lang=js&"
import style0 from "./Transmission.vue?vue&type=style&index=0&id=5428bd5f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5428bd5f",
  null
  
)

export default component.exports